export const COLUMNS = [
  "feedbackText",
  "feedbackEmoji",
  "sharesOwned",
  "authorName",
  "created",
];
